import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getOrderTimeline } from "../../api/apiOrders";

export const useGetOrderTimeline = (id, params = { limit: 100 }) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["order-timeline", id, params, i18next.language],
        queryFn: () => getOrderTimeline(id, params),
        enabled: !!id,
        retry: false,
    });

    return {
        events: data?.data || [],
        isLoading,
        error,
        refetch,
    };
};
